'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cleanLegacy = exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _legacy = require('./legacy');

var _legacy2 = _interopRequireDefault(_legacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rpCookie = function (cookie) {
    var cookieType = {
        sharedSession: 'RDSS',
        sharedPermanent: 'RDSP',
        privateSession: 'RDPS',
        privatePermanent: 'RDPP'
    };
    var cookieProp = {
        domain: window.location.hostname.split('.').slice(-2).join('.'),
        lifetime: 365,
        secure: true
    };

    function init(_ref) {
        var name = _ref.name,
            shared = _ref.shared,
            domain = _ref.domain,
            expires = _ref.expires,
            secure = _ref.secure;

        return {
            set: function set(key, value) {
                var cookieValue = _defineProperty({}, key, value);

                if (cookie.getJSON(name)) {
                    cookieValue = _extends(cookie.getJSON(name), cookieValue);
                }

                if (value === null) {
                    cookieValue = cookie.getJSON(name);
                    delete cookieValue[key];
                }

                if (shared) {
                    if (expires) {
                        cookie.set(name, cookieValue, { domain: domain, expires: expires, secure: secure });
                    } else {
                        cookie.set(name, cookieValue, { domain: domain, secure: secure });
                    }
                } else {
                    if (expires) {
                        cookie.set(name, cookieValue, { expires: expires, secure: secure });
                    } else {
                        cookie.set(name, cookieValue, { secure: secure });
                    }
                }
            },
            get: function get(key) {
                var cookieJSON = cookie.getJSON(name);
                if (!cookieJSON) {
                    return undefined;
                }
                return key ? cookieJSON[key] : cookieJSON;
            },
            remove: function remove(key) {
                this.set(key, null);
            }
        };
    }

    var sharedSession = init({
        name: cookieType.sharedSession,
        shared: true,
        domain: cookieProp.domain,
        secure: cookieProp.secure
    });
    var sharedPermanent = init({
        name: cookieType.sharedPermanent,
        shared: true,
        domain: cookieProp.domain,
        expires: cookieProp.lifetime,
        secure: cookieProp.secure
    });
    var privateSession = init({
        name: cookieType.privateSession,
        shared: false,
        secure: cookieProp.secure
    });
    var privatePermanent = init({
        name: cookieType.privatePermanent,
        shared: false,
        expires: cookieProp.lifetime,
        secure: cookieProp.secure
    });

    return {
        sharedSession: sharedSession,
        sharedPermanent: sharedPermanent,
        privateSession: privateSession,
        privatePermanent: privatePermanent
    };
}(_jsCookie2.default);

exports.default = rpCookie;
exports.cleanLegacy = _legacy2.default;


//////////////////
// WEBPACK FOOTER
// ./~/rp-cookie/lib/cookie.js
// module id = 24
// module chunks = 1